import React, { useEffect, useMemo, useState } from "react";
import * as S from "./FolderRecords.style";

function FolderRecords({}){
  
  return(
    <S.FolderRecords>
      <div className="empty-content"></div>
    </S.FolderRecords>
  )
}

export default FolderRecords;
